export default class ErrorMapper {
  mapToModel(error: any): Error {
    let message = error.message;

    if (error.response && 'data' in error.response) {
      message = error.response.data.message;
    }

    return new Error(message);
  }
}
